import { render } from "./Kitview.vue?vue&type=template&id=e835b7a2&scoped=true"
import script from "./Kitview.vue?vue&type=script&lang=js"
export * from "./Kitview.vue?vue&type=script&lang=js"

import "./Kitview.vue?vue&type=style&index=0&id=e835b7a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e835b7a2"]])

export default __exports__